/*
 * @Date: 2022-07-26 15:21:11
 * @LastEditors: lizixuan 240514049@qq.com
 * @LastEditTime: 2022-08-01 15:52:27
 * @FilePath: \hw_game_mp_gamebrain_data\frontend\src\api\v1\app_api.js
 * @Description: 
 */
import api from "../api";

const api_type = 'v1'

export const GetAppList = params => { return api.post(api_type+`/app/list`, params) }
export const RefreshAppList = params => { return api.post(api_type+`/app/refresh`, params) }
export const GetAccountPage = params => { return api.post(api_type+`/account/page`, params) }
export const StatusAccount = params => { return api.post(api_type+`/account/status`, params) }

export const GetApplyPage = params => { return api.post(api_type+`/app_apply/page`, params) }
export const ApplyDo = params => { return api.post(api_type+`/app_apply/apply`, params) }
export const ApplyHandle = params => { return api.post(api_type+`/app_apply/handle`, params) }
export const ApplyReviewer = params => { return api.post(api_type+`/app_apply/reviewer`, params) }





// WEBPACK FOOTER //
// ./src/api/v1/app_api.js